(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Carrusel-testimonios-imagenes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('foto-carousel')) {
  customElements.define('foto-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.slides = [...this.querySelectorAll('.fc-slide')];
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.index = 0;
      this.playing = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.editorPaused = false;
      if (this.slides.length < 2) return;
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index-1,true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index+1,true), options);
      this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.go(i,true),options));
      this.querySelector('[data-toggle]').addEventListener('click',()=>{this.playing=!this.playing;this.editorPaused=false;this.update();this.schedule();},options);
      this.addEventListener('focusin',()=>clearTimeout(this.timer),options);
      this.addEventListener('focusout',()=>this.schedule(),options);
      this.addEventListener('mouseenter',()=>{this.hovered=true;clearTimeout(this.timer);},options);
      this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},options);
      document.addEventListener('visibilitychange',()=>this.schedule(),options);
      this.addEventListener('shopify:block:select',event=>{const i=this.slides.findIndex(s=>s.dataset.block===event.detail.blockId);if(i>=0){this.editorPaused=true;this.go(i,true);}},options);
      this.addEventListener('shopify:block:deselect',()=>{this.editorPaused=false;this.schedule();},options);
      let startX=0,startY=0;
      const stage=this.querySelector('.fc-stage');
      stage.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;startY=e.changedTouches[0].clientY;}, {...options,passive:true});
      stage.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX;const dy=e.changedTouches[0].clientY-startY;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))this.go(this.index+(dx<0?1:-1),true);}, {...options,passive:true});
      this.update();this.schedule();
    }
    go(i,manual=false){this.index=(i+this.slides.length)%this.slides.length;this.update();if(manual)this.querySelector('[data-status]').textContent=`Imagen ${this.index+1} de ${this.slides.length}`;this.schedule();}
    update(){this.slides.forEach((s,i)=>s.hidden=i!==this.index);this.dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===this.index)));const b=this.querySelector('[data-toggle]');b.setAttribute('aria-label',this.playing?'Pausar carrusel':'Reproducir carrusel');b.querySelector('[data-symbol]').textContent=this.playing?'Ⅱ':'▶';}
    schedule(){clearTimeout(this.timer);if(this.playing&&!this.editorPaused&&!this.hovered&&!document.hidden&&!this.contains(document.activeElement))this.timer=setTimeout(()=>this.go(this.index+1),3000);}
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbc-carrusel-testimonials2026"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('foto-carousel')) {
  customElements.define('foto-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.slides = [...this.querySelectorAll('.fc-slide')];
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.index = 0;
      this.playing = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.editorPaused = false;
      if (this.slides.length < 2) return;
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index-1,true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index+1,true), options);
      this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.go(i,true),options));
      this.querySelector('[data-toggle]').addEventListener('click',()=>{this.playing=!this.playing;this.editorPaused=false;this.update();this.schedule();},options);
      this.addEventListener('focusin',()=>clearTimeout(this.timer),options);
      this.addEventListener('focusout',()=>this.schedule(),options);
      this.addEventListener('mouseenter',()=>{this.hovered=true;clearTimeout(this.timer);},options);
      this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},options);
      document.addEventListener('visibilitychange',()=>this.schedule(),options);
      this.addEventListener('shopify:block:select',event=>{const i=this.slides.findIndex(s=>s.dataset.block===event.detail.blockId);if(i>=0){this.editorPaused=true;this.go(i,true);}},options);
      this.addEventListener('shopify:block:deselect',()=>{this.editorPaused=false;this.schedule();},options);
      let startX=0,startY=0;
      const stage=this.querySelector('.fc-stage');
      stage.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;startY=e.changedTouches[0].clientY;}, {...options,passive:true});
      stage.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX;const dy=e.changedTouches[0].clientY-startY;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))this.go(this.index+(dx<0?1:-1),true);}, {...options,passive:true});
      this.update();this.schedule();
    }
    go(i,manual=false){this.index=(i+this.slides.length)%this.slides.length;this.update();if(manual)this.querySelector('[data-status]').textContent=`Imagen ${this.index+1} de ${this.slides.length}`;this.schedule();}
    update(){this.slides.forEach((s,i)=>s.hidden=i!==this.index);this.dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===this.index)));const b=this.querySelector('[data-toggle]');b.setAttribute('aria-label',this.playing?'Pausar carrusel':'Reproducir carrusel');b.querySelector('[data-symbol]').textContent=this.playing?'Ⅱ':'▶';}
    schedule(){clearTimeout(this.timer);if(this.playing&&!this.editorPaused&&!this.hovered&&!document.hidden&&!this.contains(document.activeElement))this.timer=setTimeout(()=>this.go(this.index+1),3000);}
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
